// ======================================
// Login Page Module
// ======================================

import { icons } from '../../components.js';
import { login, isAuthenticated, hasRole } from '../../lib/auth.js';

export function renderLoginPage() {
  // Redirect if already logged in
  if (isAuthenticated()) {
    setTimeout(() => {
      if (hasRole(['admin', 'manager', 'designer'])) {
        window.location.href = '/admin';
      } else {
        window.location.href = '/dashboard';
      }
    }, 0);
    return '<div class="loading">Redirecting...</div>';
  }

  return `
    <section class="auth-section">
      <div class="auth-container">
        <div class="auth-card">
          <div class="auth-header">
            <h1 class="auth-title">Welcome Back</h1>
            <p class="auth-subtitle">Sign in to your NammaVeetuInteriors account</p>
          </div>
          
          <form class="auth-form" id="login-form">
            <div class="form-group">
              <label class="form-label" for="login-email">Email Address</label>
              <input type="email" id="login-email" name="email" class="form-input" 
                     placeholder="Enter your email" required autocomplete="email">
            </div>
            
            <div class="form-group">
              <label class="form-label" for="login-password">Password</label>
              <div class="password-input-wrapper">
                <input type="password" id="login-password" name="password" class="form-input" 
                       placeholder="Enter your password" required autocomplete="current-password">
                <button type="button" class="password-toggle" data-target="login-password">
                  ${icons.eye || '<span>👁</span>'}
                </button>
              </div>
            </div>
            
            <div class="form-row form-row-between">
              <label class="checkbox-label">
                <input type="checkbox" name="remember" class="form-checkbox">
                <span>Remember me</span>
              </label>
              <a href="/forgot-password" class="auth-link">Forgot password?</a>
            </div>
            
            <div id="login-error" class="auth-error" style="display: none;"></div>
            
            <button type="submit" class="btn btn-primary btn-lg btn-block" id="login-btn">
              Sign In
            </button>
          </form>
          
          <div class="auth-footer">
            <p>Don't have an account? <a href="/register" class="auth-link">Create one</a></p>
          </div>
          
          <div class="auth-divider">
            <span>Quick Access</span>
          </div>
          
          <div class="quick-actions">
            <a href="/estimator" class="btn btn-outline btn-sm">Get Free Estimate</a>
            <a href="/contact" class="btn btn-outline btn-sm">Contact Us</a>
          </div>
        </div>
        
        <div class="auth-aside">
          <div class="auth-aside-content">
            <h2>Transform Your Home</h2>
            <p>Join hundreds of happy homeowners who trusted us with their dream interiors.</p>
            <ul class="auth-benefits">
              <li>${icons.check || '✓'} Track your project progress</li>
              <li>${icons.check || '✓'} View 3D designs online</li>
              <li>${icons.check || '✓'} Easy payment management</li>
              <li>${icons.check || '✓'} Direct designer communication</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  `;
}

export function initLoginPage() {
  const form = document.getElementById('login-form');
  const errorDiv = document.getElementById('login-error');
  const submitBtn = document.getElementById('login-btn');

  if (!form) return;

  // Password toggle
  const toggleBtn = form.querySelector('.password-toggle');
  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      const targetId = toggleBtn.dataset.target;
      const input = document.getElementById(targetId);
      if (input) {
        input.type = input.type === 'password' ? 'text' : 'password';
      }
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const email = form.email.value.trim();
    const password = form.password.value;

    // Validation
    if (!email || !password) {
      showError('Please fill in all fields');
      return;
    }

    // Disable button and show loading
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="spinner"></span> Signing in...';
    errorDiv.style.display = 'none';

    try {
      const user = await login(email, password);

      // Redirect based on role
      if (['admin', 'manager', 'designer'].includes(user.role)) {
        window.location.href = '/admin';
      } else {
        window.location.href = '/dashboard';
      }
    } catch (error) {
      showError(error.message || 'Login failed. Please try again.');
      submitBtn.disabled = false;
      submitBtn.innerHTML = 'Sign In';
    }
  });

  function showError(message) {
    errorDiv.textContent = message;
    errorDiv.style.display = 'block';
  }
}
